const imageGallery = () => {
  const init = () => {
    gallery();
  };

  const gallery = () => {
    document.addEventListener("DOMContentLoaded", function () {
      const firstImage = document.querySelector(".js-atribute-gallery a");
      firstImage.setAttribute(
        "data-elementor-lightbox-slideshow",
        "my-lightbox"
      );

      // Get the second gallery container
      const galleryImages = document.querySelectorAll(
        ".js-atribute-gallery .e-gallery-item"
      );

      // Set the same data-elementor-lightbox-slideshow attribute value for all images
      galleryImages.forEach(function (image) {
        image.setAttribute("data-elementor-lightbox-slideshow", "my-lightbox");
      });
    });
  };

  init();
};

try {
  imageGallery();
} catch (error) {
  console.log(error);
}
